import { IMyRaffleRewardClaimListItemDTO } from "@hooks/dtos/raffles/IRaffleRewardClaimDTO";
import {
  RaffleRewardClaimDeliveryTypeEnum,
  RaffleRewardClaimStatusEnum,
} from "@hooks/enums/raffle_reward_claim";

export interface IRewardClaimDetailMessage {
  id: number;
  author: "client" | "owner";
  name: string;
  text: string;
  createdAt: string;
}

export interface IRewardClaimDetailFile {
  id: number;
  claimId: number;
  name: string;
  type: string;
  status: "sent" | "waiting" | "rejected";
  createdAt?: string | null;
}

export interface IRewardClaimDetailRequirement {
  claimId: number;
  canRequest: boolean;
  instructions: string;
  requiredFiles: string[];
}

export interface IRewardClaimDetailMock
  extends IMyRaffleRewardClaimListItemDTO {
  owner: {
    atSign: string;
    name: string;
  };
  requirements: IRewardClaimDetailRequirement[];
  files: IRewardClaimDetailFile[];
  messages: IRewardClaimDetailMessage[];
}

export const rewardClaimDetailMock: IRewardClaimDetailMock = {
  raffle: {
    key: "ZVBaWw",
    name: "CP1 - iPhone + iPad + Netflix",
    campaign: "test-iphone-ipad-nf",
    status: "p",
    thumb:
      "https://images.unsplash.com/photo-1603898037225-1bea09c550c0?auto=format&fit=crop&w=400&q=80",
    finishedAt: "2026-08-01T15:00:00.000Z",
  },
  owner: {
    atSign: "centralpremios",
    name: "Central Prêmios Brasil",
  },
  winnerTicket: {
    order: 4,
    ticket: "4",
  },
  rewards: [
    {
      claimId: 1,
      reward: {
        id: 4,
        order: 1,
        name: "Netflix",
        description_short: "Assinatura Netflix Premium por 12 meses.",
        thumb:
          "https://images.unsplash.com/photo-1611162616475-46b635cb6868?auto=format&fit=crop&w=300&q=80",
        price: 720,
      },
      category: {
        id: 5,
        name: "Digital",
        description_short: "Prêmios digitais enviados ao ganhador.",
      },
      status: RaffleRewardClaimStatusEnum.WAITING_REQUEST,
      deliveryType: RaffleRewardClaimDeliveryTypeEnum.DIGITAL,
      trackingCode: null,
      requestedAt: null,
      approvedAt: null,
      sentAt: null,
      deliveredAt: null,
      questionedAt: null,
      canceledAt: null,
      updatedAt: "2026-08-01T16:00:00.000Z",
    },
    {
      claimId: 2,
      reward: {
        id: 7,
        order: 2,
        name: "iPad Pro",
        description_short: "iPad Pro lacrado com garantia nacional.",
        thumb:
          "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?auto=format&fit=crop&w=300&q=80",
        price: 7899.9,
      },
      category: {
        id: 1,
        name: "Eletrônicos",
        description_short: "Produtos eletrônicos para entrega física.",
      },
      status: RaffleRewardClaimStatusEnum.REQUESTED,
      deliveryType: RaffleRewardClaimDeliveryTypeEnum.SHIPPING,
      trackingCode: null,
      requestedAt: "2026-08-01T16:20:00.000Z",
      approvedAt: null,
      sentAt: null,
      deliveredAt: null,
      questionedAt: null,
      canceledAt: null,
      updatedAt: "2026-08-01T16:20:00.000Z",
    },
    {
      claimId: 3,
      reward: {
        id: 8,
        order: 3,
        name: "iPhone 15 PRO",
        description_short: "iPhone 15 PRO 256 GB lacrado.",
        thumb:
          "https://images.unsplash.com/photo-1695048133142-1a20484d2569?auto=format&fit=crop&w=300&q=80",
        price: 7899.9,
      },
      category: {
        id: 1,
        name: "Eletrônicos",
        description_short: "Produtos eletrônicos para entrega física.",
      },
      status: RaffleRewardClaimStatusEnum.PENDING_INFORMATION,
      deliveryType: RaffleRewardClaimDeliveryTypeEnum.PICKUP,
      trackingCode: null,
      requestedAt: "2026-08-01T16:25:00.000Z",
      approvedAt: null,
      sentAt: null,
      deliveredAt: null,
      questionedAt: null,
      canceledAt: null,
      updatedAt: "2026-08-01T17:10:00.000Z",
    },
  ],
  lastUpdateAt: "2026-08-01T17:10:00.000Z",
  requirements: [
    {
      claimId: 1,
      canRequest: true,
      instructions:
        "Informe o e-mail que receberá o acesso digital e confirme seus dados de contato.",
      requiredFiles: ["Documento com foto", "E-mail de recebimento"],
    },
    {
      claimId: 2,
      canRequest: false,
      instructions:
        "Esta solicitação já foi enviada. Aguarde a validação do endereço para envio.",
      requiredFiles: ["Documento com foto", "Comprovante de endereço"],
    },
    {
      claimId: 3,
      canRequest: true,
      instructions:
        "O proprietário solicitou informações adicionais para retirada presencial.",
      requiredFiles: ["Documento com foto", "Termo de retirada assinado"],
    },
  ],
  files: [
    {
      id: 1,
      claimId: 2,
      name: "documento-frente.pdf",
      type: "Documento com foto",
      status: "sent",
      createdAt: "2026-08-01T16:32:00.000Z",
    },
    {
      id: 2,
      claimId: 3,
      name: "termo-retirada.pdf",
      type: "Termo de retirada assinado",
      status: "waiting",
      createdAt: null,
    },
  ],
  messages: [
    {
      id: 1,
      author: "owner",
      name: "Central Prêmios Brasil",
      text: "Olá! Cada prêmio possui uma validação própria. Envie os arquivos conforme o tipo de entrega.",
      createdAt: "2026-08-01T16:15:00.000Z",
    },
    {
      id: 2,
      author: "client",
      name: "Você",
      text: "Certo, vou atualizar as informações do prêmio que ainda está pendente.",
      createdAt: "2026-08-01T16:31:00.000Z",
    },
  ],
};
